"use client"

import styled from "@emotion/styled"
import SidebarForm from "./Form"
import PartnershipSection from "./PartnershipSection"

// Form sidebar
const FormSidebar = styled.div`
  width: 224px;
  ${(props) => props.theme.breakpoints.up("xl")} {
    width: 336px;
  }

  background-color: #09882c;
  position: fixed;
  right: 0;
  top: 0;
  height: 100vh;
  z-index: 10;
  overflow-y: auto;
`

const FormContainer = styled.div`
  padding: 105px 0 0 0;
  padding-bottom: 16px;
  ${(props) => props.theme.breakpoints.up("xl")} {
    padding: 158px 0 0 0;
    padding-bottom: 16px;
  }
`

const SectionDivider = styled.div`
  height: 1px;
  background-color: white;
  margin-bottom: 16px;
  margin: 0 26px;
  ${(props) => props.theme.breakpoints.up("xl")} {
    margin-bottom: 25px;
    margin: 0 39px;
  }
`

export default function Sidebar() {
  return (
    <FormSidebar>
      <FormContainer>
        <PartnershipSection />
        <SectionDivider />

        <SidebarForm />
      </FormContainer>
    </FormSidebar>
  )
}
